import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AdminNavigationItem } from '../../models/admin-navigation-itm';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';

@Component({
    selector: 'app-admin-navigation',
    templateUrl: './admin-navigation.component.html',
    styleUrls: ['./admin-navigation.component.scss'],
    standalone: false,
})
export class AdminNavigationComponent implements OnInit {
    selectedNavItem: AdminNavigationItem;
    isCreditsAdmin: boolean;
    @Output()
    selectNavigationItemEvent = new EventEmitter<AdminNavigationItem>();

    constructor(private authenticationService: AuthenticationService) {}

    ngOnInit(): void {
        this.isCreditsAdmin = this.authenticationService.isCreditsAdmin();
        this.selectedNavItem = AdminNavigationItem.User;
        this.selectNavigationItemEvent.emit(this.selectedNavItem);
    }

    clickNavigation(item: string): void {
        const oldItem = this.selectedNavItem;
        if (AdminNavigationItem.User === item) {
            this.selectedNavItem = AdminNavigationItem.User;
        } else if (AdminNavigationItem.Trainings === item) {
            this.selectedNavItem = AdminNavigationItem.Trainings;
        } else if (AdminNavigationItem.Performance === item) {
            this.selectedNavItem = AdminNavigationItem.Performance;
        } else if (AdminNavigationItem.Token === item) {
            this.selectedNavItem = AdminNavigationItem.Token;
        } else if (AdminNavigationItem.Credits === item) {
            this.selectedNavItem = AdminNavigationItem.Credits;
        } else if (AdminNavigationItem.Settings === item) {
            this.selectedNavItem = AdminNavigationItem.Settings;
        }

        if (oldItem !== this.selectedNavItem) {
            this.selectNavigationItemEvent.emit(this.selectedNavItem);
        }
    }

    /**
     * Reverts the highlighted nav item without emitting a navigation event.
     * Used by the parent to keep the highlight in sync when a tab switch is
     * cancelled (e.g. unsaved changes).
     */
    resetSelection(item: AdminNavigationItem): void {
        this.selectedNavItem = item;
    }

    getStyleClassForNavItem(item: string): string {
        if (
            this.selectedNavItem !== undefined &&
            this.selectedNavItem === item
        ) {
            return 'nav-link nav-item item-text active';
        }

        return 'nav-link nav-item item-text';
    }
}
